import App from 'app/app.js';
import 'app/components/core/confirm-modal/confirm-modal.js';
import 'app/components/core/accordion/accordion.js';
import 'app/components/core/mobile-modal-window/mobile-modal-window.js';

import 'app/components/package-customize/customize-sheet-item/customize-sheet-item.js';
import 'app/components/package-customize/customize-sheet/customize-sheet.js';
import 'app/components/package-customize/customize-preview/customize-preview.js';
import 'app/components/package-customize/select-photo-carousel/select-photo-carousel';
import 'app/components/package-customize/category-list/category-list.js';

import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';
import '@app/service/cropsCustomization/CustomizationImageService';

function LtCustomizeLookSelectionCtrl(
  $timeout,
  $scope,
  $window,
  $filter,
  ShoppingCartStore,
  LooksStore,
  JobStore,
  CustomizationImageService,
  SubjectStore
) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.selectedLook = {};
  this.favouriteLooks = [];
  this.defaultLook;

  this.init = function () {
    this.favouriteLooks = ShoppingCartStore.getCurrentSubject()?.favouriteLooks ?? [];
    this.defaultLook = LooksStore.getDefaultLook();
  };

  const unwatchOrderLine = $scope.$watch('selectedOrderLineDetail', (selectedOrderLineDetail) => {
    if (selectedOrderLineDetail) {
      if (selectedOrderLineDetail.look) {
        this.selectedLook = selectedOrderLineDetail.look;
      } else {
        this.changeLook(this.defaultLook);
      }
    }
    this.previewImage = { ...this.defaultLook, ...this.selectedLook };
    this.previewItem = { ...$scope.selectedOrderLineDetail?.item };
    this.orderLineDetail = [{ item: { ...this.previewItem }, look: { ...this.previewImage } }];

    const cyopOrderLineDetails = ($scope.orderLine?.orderLineDetails ?? []).map((orderLineDetail) => ({
      ...orderLineDetail,
      masked: true
    }));
    cyopOrderLineDetails[$scope.selectedSheetIndex] = this.orderLineDetail[0];

    if (this.pcbCompatibleJob) {
      const newSkuCode = selectedOrderLineDetail?.item?.skuCode;
      const skuCodeChanged = newSkuCode !== this._lastInitSkuCode;

      if (skuCodeChanged) {
        this._lastInitSkuCode = newSkuCode;
        this.availableBg = null;
        this.unwatchActiveOrderLineDetails?.();

        CustomizationImageService.init(
          [
            {
              orderLineDetails: cyopOrderLineDetails
            }
          ],
          {
            productSkuCode: $scope.orderLine?.orderable?.skuCode,
            editableOrderLine: $scope.editableOrderLine
          }
        );

        if ($scope.selectedSheetIndex !== -1) {
          this.unwatchActiveOrderLineDetails = $scope.$watch(
            () => CustomizationImageService.getSelectedOrderLineDetail(),
            (selectedOrderLineDetail) => {
              this.previewImage = { ...selectedOrderLineDetail.look };
              this.previewItem = { ...selectedOrderLineDetail.item };

              this.selectedLook = selectedOrderLineDetail.look;
              this.orderLineDetail = [{ ...selectedOrderLineDetail }];
            }
          );

          this.selectLookCategory(CustomizationImageService.getSelectedLookCategory());
          this.cropsTitle = this.previewItem?.nameDesc;
        }
      }
    }

    this.lookCategories = LooksStore.getLookCategories()
      .filter(
        (lookCategory) => !this.pcbCompatibleJob || CustomizationImageService.getBgByCategory(lookCategory).length > 0
      )
      .map((lookCategory) => ({
        lookCategory: lookCategory,
        lookName: $filter('ltTranslateFilter')(lookCategory)
      }));
  });

  $scope.$on('$destroy', () => {
    unwatchOrderLine();
    this.unwatchActiveOrderLineDetails?.();
  });

  this.goToPreviousPage = function () {
    $scope.goToPreviousPage();

    if (this.pcbCompatibleJob && !$scope.selectedOrderLineDetail.look) {
      this.selectedLook = null;
      $scope.selectedOrderLineDetail.item = null;
    }
  };

  this.getSheetSize = function () {
    var sheetSize = '';
    if ($scope.selectedOrderLineDetail && $scope.selectedOrderLineDetail.item.parsedSheets.length > 0) {
      R.forEach(function (parsedSheets) {
        if (parsedSheets.dimensions) {
          sheetSize = sheetSize + parsedSheets.dimensions + ' ';
        } else {
          sheetSize = sheetSize + parsedSheets.description + ' ';
        }
      })($scope.selectedOrderLineDetail.item.parsedSheets);
    }
    return sheetSize;
  };

  this.getSelectedLook = function () {
    var that = this;
    return R.find(function (look) {
      return look.lookNumber === that.selectedLook.lookNumber && look.orientation === that.selectedLook.orientation;
    })(this.favouriteLooks);
  };

  this.getSelectedLookWithBearerToken = function () {
    const look = this.getSelectedLook();
    if (!look) {
      return look;
    }
    const key = `${look.lookNumber}_${look.orientation}`;
    if (!this._cachedLookWithToken || this._cachedLookWithToken._key !== key) {
      this._cachedLookWithToken = { ...look, bearerTokenURL: SubjectStore.getBearerTokenURL(), _key: key };
    }
    return this._cachedLookWithToken;
  };

  this.changeLook = function (look) {
    if (this.selectedLook) {
      this.prevLookNumber = this.selectedLook.lookNumber;
      this.previousLook = this.getLookFromFavorites(this.selectedLook.lookNumber);
    }
    if (this.prevLookNumber != look.lookNumber) {
      this.addLookToFavourites(look, true);
    }
    this.selectedLook = look;
  };

  this.addLookToFavourites = function (look, lookChange) {
    var cloneObj = {
      category: look.category,
      lookNumber: look.lookNumber,
      orientation: look.orientation,
      previewImageLocationF: look.previewImageLocationF,
      isRemovable: true
    };
    if (this.favouriteLooks.length == 0) {
      this.favouriteLooks.push(cloneObj);
    } else {
      var isExist = !!R.find(function (item) {
        return item.lookNumber === look.lookNumber;
      })(this.favouriteLooks);

      if (lookChange) {
        if (!isExist) {
          if (
            !this.previousLook ||
            this.lookAlreadyMappedInOrderLineDetail(this.prevLookNumber) ||
            (this.previousLook && !this.previousLook.isRemovable)
          ) {
            this.favouriteLooks.push(cloneObj);
          } else {
            var prevLookIndex = this.findPrevLookIndexInFavorites(this.prevLookNumber);
            this.favouriteLooks[prevLookIndex] = cloneObj;
          }
        } else {
          if (!this.lookAlreadyMappedInOrderLineDetail(this.prevLookNumber)) {
            this.removeLookfromFavorites(this.previousLook);
          }
        }
      } else {
        if (!isExist) {
          this.favouriteLooks.push(cloneObj);
        }
      }
    }
  };

  this.removeLookfromFavorites = function (look) {
    if (!look) {
      return;
    }
    var favoriteLook = this.getLookFromFavorites(look.lookNumber);
    var index = this.getLookIndexInFavorites(look.lookNumber);
    if (index > -1 && favoriteLook.isRemovable) {
      this.favouriteLooks.splice(index, 1);
    }
  };

  this.lookAlreadyMappedInOrderLineDetail = function (prevLookNumber) {
    var flag = false;
    if (!$scope.orderLine || !$scope.orderLine.orderLineDetails) {
      return false;
    }
    for (var i = 0; i < $scope.orderLine.orderLineDetails.length; i++) {
      if (
        $scope.orderLine.orderLineDetails[i] !== $scope.selectedOrderLineDetail &&
        $scope.orderLine.orderLineDetails[i].look &&
        $scope.orderLine.orderLineDetails[i].look.lookNumber == prevLookNumber
      ) {
        flag = true;
        break;
      }
    }
    return flag;
  };

  this.findPrevLookIndexInFavorites = function (prevLookNumber) {
    return R.findIndex(R.propEq('lookNumber', prevLookNumber))(this.favouriteLooks);
  };

  this.getLookFromFavorites = function (lookNumber) {
    return R.find(R.propEq('lookNumber', lookNumber), this.favouriteLooks);
  };

  this.getLookIndexInFavorites = function (lookNumber) {
    return R.findIndex(R.propEq('lookNumber', lookNumber), this.favouriteLooks);
  };

  this.chooseLook = function () {
    $scope.onSelectedLook({ selectedLook: this.selectedLook });
  };

  // -------------- NEW UI -------------------

  this.pcbCompatibleJob = JobStore.getJob()?.pcbCompatible ?? false;

  this.selectedLookCategory = this.lookCategories?.[0].lookCategory;

  this.refreshActivePose = () => {
    this.availableBg = CustomizationImageService.getBgLooksByCategory(this.selectedLookCategory);
    this.selectedBgIndex = this.availableBg.findIndex(
      (bg) => bg.backgroundImageId === CustomizationImageService.getSelectedBgId()
    );
    const bearerTokenURL = SubjectStore.getBearerTokenURL();
    this.availablePoses = CustomizationImageService.getLooksBySelectedBgId().map((pose) => {
      if (!pose.bearerTokenURL) {
        pose.bearerTokenURL = bearerTokenURL;
      }
      return pose;
    });
    const activeLook = CustomizationImageService.getSelectedLook();
    this.selectedPoseIndex = this.availablePoses.findIndex((pose) => pose.layoutThemeID === activeLook.layoutThemeID);
  };

  this.getActiveLook = () => CustomizationImageService.getSelectedLook();

  this.selectLookCategory = (lookCategory) => {
    this.selectedLookCategory = lookCategory;
    this.refreshActivePose();
  };

  this.selectedPose = (value) => {
    CustomizationImageService.selectPoseByLook(value);
  };
  this.selectedBackground = (value) => {
    CustomizationImageService.selectBg(value.backgroundImageId);
    this.refreshActivePose();
  };

  this.closeItemMobileModal = () => {
    this.goToPreviousPage();
  };
  this.closeAndCustomizeItemMobileModal = () => {
    this.chooseLook();
  };

  this.activeBgNotInCategory = () => {
    return this.availableBg?.every((bg) => bg.backgroundImageId !== CustomizationImageService.getSelectedBgId());
  };
}

App.controller('LtCustomizeLookSelectionCtrl', [
  '$timeout',
  '$scope',
  '$window',
  '$filter',
  'ShoppingCartStore',
  'LooksStore',
  'JobStore',
  'CustomizationImageService',
  'SubjectStore',
  LtCustomizeLookSelectionCtrl
]);
